import { Flex } from "@chakra-ui/react";
import React from "react";
import { FiliaisGrids, GroupDate } from "../../components";

const Filiais = () => {
  return (
    <Flex
      justifyContent={"center"}
      alignItems="center"
      width={"full"}
      height={"100%"}
      gap={2}
    >
      <Flex
        width={"110%"}
        height="full"
        borderColor="gray.300"
        borderRadius={"md"}
        p="4"
        flexDirection={"column"}
        justifyContent={"center"}
        gap={5}
      >
        <h1>Filiais</h1>
        <FiliaisGrids />
      </Flex>
    </Flex>
  );
};

export default Filiais;
